import {Box, Grid} from '@mui/material';
import React, {FC} from 'react';

interface PropsFromParent {
  imgString: string;
}
export const ImageRow: FC<PropsFromParent> = React.memo((props) => {
  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center">
          <img style={{maxWidth: 500, maxHeight: 420}} src={props.imgString}></img>
        </Box>
      </Grid>
    </>
  );
});
